import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Layout from "../components/LayoutComponents/Layout";
import "../assets/css/pages/home/home.css";
import Background1 from "../assets/images/Home/background.png";
import Background2 from "../assets/images/Home/background1.png";
import Background3 from "../assets/images/Home/background2.png";
import HomeImage from "../assets/images/Home/image.png";
import { accessPagesAction } from "../actions/accessPagesActions";

const Home = ({ userInfo, currentUserRole }) => {
  const userInfoStore = useSelector((state) => state.userProfileInfo.response);
  const [name, setName] = useState(userInfoStore?.username);

  const dispatch = useDispatch();
  const { response: accessPagesState, loading: accessPagesStateLoading } =
    useSelector((state) => state?.accessPages);

  useEffect(() => {
    setName(
      userInfoStore?.username !== undefined ? userInfoStore?.username : ""
    );
  }, [userInfoStore]);

  useEffect(() => {
    if (!accessPagesStateLoading) dispatch(accessPagesAction());
  }, []);

  return (
    <Layout title={`Welcome ${name}`}>
      <section class="intro">
        <div
          class="background"
          style={{
            background: `url(${Background1})`,
          }}
        ></div>
        <div class="intro-content">
          <h2>
            About <strong className="strong-new">CloudAct</strong>
          </h2>
          <p>
            Digital dynamic practical and expert accounting and business
            advisory firm that gives you back the most important commodity –
            Time!
          </p>
        </div>

        <button>Learn More</button>
      </section>

      <section class="why-us">
        <div class="why">
          <div class="why-header">
            <h3>
              Why we set-up <strong className="strong-new">CloudAct?</strong>
            </h3>
            <p>
              To power your business into the digital era with extremely
              efficient processes. A simple and
              <strong className="strong-new">
                stress-free experience
              </strong>{" "}
              that leverages technology and fires your business on all
              cylinders.
            </p>
          </div>

          <div class="why-content">
            <div class="why-item">
              <svg
                width="72"
                height="72"
                viewBox="0 0 72 72"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clip-path="url(#clip0_8852_98192)">
                  <path
                    d="M61.4655 12.5508C67.1473 18.7179 70.6175 26.9539 70.6175 36.0004C70.6175 55.119 55.1187 70.6177 36.0002 70.6177C16.8816 70.6177 1.38281 55.119 1.38281 36.0004C1.38281 16.8818 16.8816 1.38313 36.0002 1.38313C37.4112 1.38294 38.8208 1.46804 40.2215 1.63794"
                    stroke="#307FF4"
                    stroke-width="2.5"
                    stroke-miterlimit="10"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M22.4443 14.4505C32.2784 8.25193 45.4316 9.43571 53.9979 18.0021C63.938 27.9422 63.938 44.058 53.9979 53.9981C44.058 63.9381 27.942 63.9381 18.002 53.9981C9.42287 45.4191 8.24823 32.2397 14.4779 22.4009"
                    stroke="#307FF4"
                    stroke-width="2.5"
                    stroke-miterlimit="10"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M61.2188 17.6958V12.3521H66.5625"
                    stroke="#307FF4"
                    stroke-width="2.5"
                    stroke-miterlimit="10"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M32.5625 36.0002C32.5625 37.8991 34.1019 39.4385 36.0008 39.4385C37.8996 39.4385 39.439 37.8991 39.439 36.0002C39.439 34.1014 37.8996 32.5619 36.0008 32.5619C34.1019 32.5619 32.5625 34.1014 32.5625 36.0002Z"
                    stroke="#307FF4"
                    stroke-width="2.5"
                    stroke-miterlimit="10"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M56.0156 36.0234H54.2812"
                    stroke="#307FF4"
                    stroke-width="2.5"
                    stroke-miterlimit="10"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M15.9844 35.9775H17.7187"
                    stroke="#307FF4"
                    stroke-width="2.5"
                    stroke-miterlimit="10"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M36.0234 15.9849V17.7192"
                    stroke="#307FF4"
                    stroke-width="2.5"
                    stroke-miterlimit="10"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M35.9766 56.0156V54.2813"
                    stroke="#307FF4"
                    stroke-width="2.5"
                    stroke-miterlimit="10"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M33.5689 33.5688L27.957 27.9569"
                    stroke="#307FF4"
                    stroke-width="2.5"
                    stroke-miterlimit="10"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M38.4297 33.5688L48.8919 23.1067"
                    stroke="#307FF4"
                    stroke-width="2.5"
                    stroke-miterlimit="10"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_8852_98192">
                    <rect width="72" height="72" fill="white" />
                  </clipPath>
                </defs>
              </svg>

              <div>
                <h4>TO SAVE YOUR TIME AND NERVES</h4>
                <p>
                  No more being hostage to your legacy systems and processes.
                  CloudAct works collaboratively with you to develop solutions
                  that propel the growth of business to the next level.
                  Providing high-value professional services across all our
                  service lines.
                </p>
              </div>
            </div>

            <div class="why-item">
              <svg
                width="72"
                height="72"
                viewBox="0 0 72 72"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clip-path="url(#clip0_8852_77471)">
                  <path
                    d="M61.9987 44.9665C61.425 44.7415 60.7725 45.0227 60.5363 45.5965C59.0946 49.26 57.0487 52.6559 54.4837 55.6427L49.77 61.144C49.59 61.3465 49.5 61.6052 49.5 61.8752V69.7502H24.75V63.0002H35.0438C36.765 63.0002 38.3062 62.044 39.0713 60.514L40.3875 57.8815C40.4542 57.7494 40.4941 57.6054 40.5047 57.4579C40.5154 57.3103 40.4966 57.1621 40.4495 57.0219C40.4024 56.8816 40.3279 56.7521 40.2304 56.6409C40.1328 56.5297 40.0142 56.4389 39.8813 56.374C39.7492 56.3072 39.6052 56.2674 39.4577 56.2567C39.3101 56.2461 39.1619 56.2649 39.0217 56.312C38.8814 56.3591 38.7519 56.4335 38.6407 56.5311C38.5295 56.6286 38.4387 56.7473 38.3737 56.8802L37.0575 59.5127C36.8712 59.8876 36.5841 60.203 36.2283 60.4236C35.8726 60.6442 35.4623 60.7612 35.0438 60.7615H14.625C12.7688 60.7615 11.25 59.2427 11.25 57.3865V48.3865C11.25 47.7677 10.7437 47.2615 10.125 47.2615H6.82875C5.54625 47.2615 4.5 46.2152 4.5 44.9327C4.5 44.4715 4.635 44.0215 4.89375 43.639L11.0588 34.3802C11.1818 34.1972 11.2483 33.982 11.25 33.7615V32.6365C11.25 22.309 17.3812 12.9715 26.865 8.87646C27.4387 8.62896 27.6975 7.96521 27.45 7.40271C27.2025 6.84021 26.5387 6.57021 25.9762 6.81771C20.9334 8.99506 16.6385 12.6014 13.6217 17.1916C10.6049 21.7818 8.99823 27.1549 9 32.6477V33.4352L3.015 42.4015C2.50875 43.1552 2.25 44.0327 2.25 44.944C2.25297 46.1574 2.73633 47.3203 3.59437 48.1783C4.45241 49.0364 5.6153 49.5197 6.82875 49.5227H9V57.3977C9 60.5027 11.52 63.0227 14.625 63.0227H22.5V70.8977C22.5 71.5165 23.0063 72.0227 23.625 72.0227H50.625C51.2438 72.0227 51.75 71.5165 51.75 70.8977V62.314L56.1938 57.1277C58.9275 53.944 61.0875 50.344 62.6287 46.4402C62.8537 45.8665 62.5725 45.214 61.9987 44.9777V44.9665Z"
                    fill="#307FF4"
                  />
                  <path
                    d="M40.5 25.875H31.5C30.8812 25.875 30.375 26.3812 30.375 27C30.375 27.6187 30.8812 28.125 31.5 28.125H39.375V31.5C39.375 32.1188 39.8813 32.625 40.5 32.625C41.1187 32.625 41.625 32.1188 41.625 31.5V27C41.625 26.3812 41.1187 25.875 40.5 25.875ZM40.5 34.875H32.625V31.5C32.625 30.8812 32.1187 30.375 31.5 30.375C30.8812 30.375 30.375 30.8812 30.375 31.5V36C30.375 36.6187 30.8812 37.125 31.5 37.125H40.5C41.1187 37.125 41.625 36.6187 41.625 36C41.625 35.3813 41.1187 34.875 40.5 34.875Z"
                    fill="#307FF4"
                  />
                  <path
                    d="M36 32.625C36.6213 32.625 37.125 32.1213 37.125 31.5C37.125 30.8787 36.6213 30.375 36 30.375C35.3787 30.375 34.875 30.8787 34.875 31.5C34.875 32.1213 35.3787 32.625 36 32.625Z"
                    fill="#307FF4"
                  />
                  <path
                    d="M50.625 13.5C50.625 15.3562 52.1438 16.875 54 16.875C54.2812 16.875 54.5512 16.83 54.8212 16.7625L57.5662 20.8687C57.78 21.1837 58.1287 21.375 58.5 21.375H60.9525C61.4137 22.68 62.6513 23.625 64.125 23.625C65.9813 23.625 67.5 22.1062 67.5 20.25C67.5 18.3938 65.9813 16.875 64.125 16.875C62.6625 16.875 61.425 17.82 60.9525 19.125H59.0962L56.6887 15.5138C57.1162 14.9513 57.375 14.2537 57.375 13.5C57.375 11.6438 55.8562 10.125 54 10.125C52.1438 10.125 50.625 11.6438 50.625 13.5ZM64.125 19.125C64.7437 19.125 65.25 19.6313 65.25 20.25C65.25 20.8687 64.7437 21.375 64.125 21.375C63.5063 21.375 63 20.8687 63 20.25C63 19.6313 63.5063 19.125 64.125 19.125ZM55.125 13.5C55.125 14.1188 54.6187 14.625 54 14.625C53.3813 14.625 52.875 14.1188 52.875 13.5C52.875 12.8812 53.3813 12.375 54 12.375C54.6187 12.375 55.125 12.8812 55.125 13.5ZM66.375 31.5C64.5187 31.5 63 33.0187 63 34.875C63 35.3925 63.1237 35.8763 63.3375 36.3263L56.9137 42.75H47.25C46.6312 42.75 46.125 43.2562 46.125 43.875V47.4525C44.82 47.9137 43.875 49.1512 43.875 50.625C43.875 52.4813 45.3938 54 47.25 54C49.1062 54 50.625 52.4813 50.625 50.625C50.625 49.1625 49.68 47.925 48.375 47.4525V45H57.375C57.6788 45 57.96 44.8762 58.1737 44.6737L64.935 37.9125C65.3738 38.1263 65.8575 38.25 66.3862 38.25C68.2425 38.25 69.7612 36.7313 69.7612 34.875C69.7612 33.0187 68.2425 31.5 66.3862 31.5H66.375ZM47.25 51.75C46.6312 51.75 46.125 51.2438 46.125 50.625C46.125 50.0062 46.6312 49.5 47.25 49.5C47.8688 49.5 48.375 50.0062 48.375 50.625C48.375 51.2438 47.8688 51.75 47.25 51.75ZM66.375 36C66.0799 35.9988 65.797 35.8816 65.5875 35.6737V35.6625C65.5875 35.6513 65.5875 35.6625 65.5763 35.6625C65.4718 35.5598 65.3891 35.4372 65.3331 35.3019C65.277 35.1666 65.2488 35.0214 65.25 34.875C65.25 34.2563 65.7563 33.75 66.375 33.75C66.9937 33.75 67.5 34.2563 67.5 34.875C67.5 35.4937 66.9937 36 66.375 36Z"
                    fill="#307FF4"
                  />
                  <path
                    d="M30.375 6.5475V10.125C30.375 10.4738 30.5437 10.8113 30.825 11.025L34.875 14.0625V21.375H32.625V16.875C32.625 16.2563 32.1187 15.75 31.5 15.75H27.9225C27.6918 15.0926 27.2627 14.523 26.6944 14.12C26.1261 13.717 25.4467 13.5003 24.75 13.5C22.8938 13.5 21.375 15.0188 21.375 16.875C21.375 18.7313 22.8938 20.25 24.75 20.25C26.2125 20.25 27.45 19.305 27.9225 18H30.375V21.375H29.25C27.3938 21.375 25.875 22.8937 25.875 24.75V25.875H21.375C20.7562 25.875 20.25 26.3813 20.25 27C20.25 27.6187 20.7562 28.125 21.375 28.125H25.875V30.375H19.125C18.5062 30.375 18 30.8813 18 31.5C18 32.1188 18.5062 32.625 19.125 32.625H25.875V34.875H23.625C23.0062 34.875 22.5 35.3812 22.5 36C22.5 36.6188 23.0062 37.125 23.625 37.125H25.875V38.25C25.875 40.1063 27.3938 41.625 29.25 41.625H30.375V46.125C30.375 46.7438 30.8813 47.25 31.5 47.25C32.1187 47.25 32.625 46.7438 32.625 46.125V41.625H34.875V48.375C34.875 48.9938 35.3813 49.5 36 49.5C36.6187 49.5 37.125 48.9938 37.125 48.375V41.625H39.375V43.875C39.375 44.4938 39.8813 45 40.5 45C41.1187 45 41.625 44.4938 41.625 43.875V41.625H42.75C44.6063 41.625 46.125 40.1063 46.125 38.25H49.7025C50.1637 39.555 51.4012 40.5 52.875 40.5C54.7313 40.5 56.25 38.9813 56.25 37.125C56.25 36.9225 56.2275 36.72 56.1938 36.5288L60.4237 32.2987C60.5279 32.1946 60.6105 32.0709 60.6669 31.9349C60.7233 31.7988 60.7523 31.6529 60.7523 31.5056C60.7523 31.3583 60.7233 31.2125 60.6669 31.0764C60.6105 30.9403 60.5279 30.8167 60.4237 30.7125C60.3196 30.6083 60.1959 30.5257 60.0599 30.4694C59.9238 30.413 59.7779 30.384 59.6306 30.384C59.4833 30.384 59.3375 30.413 59.2014 30.4694C59.0653 30.5257 58.9417 30.6083 58.8375 30.7125L55.0125 34.5375C54.4275 34.0537 53.6962 33.7612 52.8862 33.7612C51.4237 33.7612 50.1862 34.7062 49.7137 36.0112H46.1362V27.0112H50.8387C51.3 28.3162 52.5375 29.2612 54.0112 29.2612C55.8675 29.2612 57.3862 27.7425 57.3862 25.8862C57.3862 24.03 55.8675 22.5112 54.0112 22.5112C52.5487 22.5112 51.3112 23.4563 50.8387 24.7612H46.1362C46.1362 23.2987 45.1912 22.0613 43.8862 21.5888V18.9225C45.1912 18.4613 46.1362 17.2237 46.1362 15.75C46.1362 14.2762 45.1912 13.05 43.8862 12.5775V11.7113L49.185 6.4125C49.6238 6.62625 50.1075 6.75 50.6362 6.75C52.4925 6.75 54.0112 5.23125 54.0112 3.375C54.0112 1.51875 52.4925 0 50.6362 0C48.78 0 47.2612 1.51875 47.2612 3.375C47.2612 3.8925 47.385 4.37625 47.5988 4.82625L41.9625 10.4625C41.8582 10.5676 41.7757 10.6923 41.7198 10.8294C41.6638 10.9664 41.6354 11.1132 41.6362 11.2613V12.5887C40.3312 13.05 39.3862 14.2875 39.3862 15.7613C39.3862 17.235 40.3312 18.4613 41.6362 18.9338V21.3862H37.1362V13.5113C37.1362 13.1625 36.9675 12.825 36.6863 12.6112L32.6363 9.57375V6.55875C33.9412 6.0975 34.8862 4.86 34.8862 3.38625C34.8862 1.53 33.3675 0.01125 31.5113 0.01125C29.655 0.01125 28.1363 1.53 28.1363 3.38625C28.1363 4.84875 29.0813 6.08625 30.3863 6.55875L30.375 6.5475ZM24.75 18C24.1312 18 23.625 17.4937 23.625 16.875C23.625 16.2563 24.1312 15.75 24.75 15.75C25.3688 15.75 25.875 16.2563 25.875 16.875C25.875 17.4937 25.3688 18 24.75 18ZM52.875 36C53.4938 36 54 36.5062 54 37.125C54 37.7438 53.4938 38.25 52.875 38.25C52.2562 38.25 51.75 37.7438 51.75 37.125C51.75 36.5062 52.2562 36 52.875 36ZM54 24.75C54.6188 24.75 55.125 25.2563 55.125 25.875C55.125 26.4937 54.6188 27 54 27C53.3812 27 52.875 26.4937 52.875 25.875C52.875 25.2563 53.3812 24.75 54 24.75ZM50.625 2.25C51.2438 2.25 51.75 2.75625 51.75 3.375C51.75 3.99375 51.2438 4.5 50.625 4.5C50.3299 4.49876 50.047 4.38159 49.8375 4.17375V4.1625C49.8375 4.15125 49.8375 4.1625 49.8263 4.1625C49.7218 4.05984 49.6391 3.93722 49.5831 3.80192C49.527 3.66663 49.4988 3.52144 49.5 3.375C49.5 2.75625 50.0062 2.25 50.625 2.25ZM43.875 38.25C43.875 38.8688 43.3687 39.375 42.75 39.375H29.25C28.6313 39.375 28.125 38.8688 28.125 38.25V24.75C28.125 24.1313 28.6313 23.625 29.25 23.625H42.75C43.3687 23.625 43.875 24.1313 43.875 24.75V38.25ZM42.75 14.625C43.3687 14.625 43.875 15.1313 43.875 15.75C43.875 16.3687 43.3687 16.875 42.75 16.875C42.1313 16.875 41.625 16.3687 41.625 15.75C41.625 15.1313 42.1313 14.625 42.75 14.625ZM31.5 2.25C32.1187 2.25 32.625 2.75625 32.625 3.375C32.625 3.99375 32.1187 4.5 31.5 4.5C30.8813 4.5 30.375 3.99375 30.375 3.375C30.375 2.75625 30.8813 2.25 31.5 2.25Z"
                    fill="#307FF4"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_8852_77471">
                    <rect width="72" height="72" fill="white" />
                  </clipPath>
                </defs>
              </svg>

              <div>
                <h4>TO CONNECT YOU WITH THE FUTURE</h4>
                <p>
                  We are breaking new ground. We're innovating. We're
                  reimagining the possible. CloudAct team challenges existing
                  approaches to everything. We build forward-thinking technology
                  supported solution that integrate and then unlock business
                  value for shareholders/owners/other stakeholders.
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="get-connected">
          <h3>Ready to get connected?</h3>
          <p>The Rest is Easy. You Will Never Look Back.</p>

          <svg
            class="arrow-1"
            viewBox="0 0 768 214"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M698.289 246.067C674.206 229 609.444 194.853 552.115 169.836C491.812 143.521 445.076 138.642 402.137 153.883C377.181 162.741 375.481 193.95 414.236 208.848C452.992 223.746 506.28 180.4 472.556 134.247C438.832 88.0941 343.645 102.136 273.604 108.179"
              stroke="#C5E4FE"
              stroke-width="3"
              stroke-linecap="round"
              stroke-dasharray="8 8"
            />
            <path
              d="M332.909 128.006L372.462 171.488L349.963 92.8319L71.4301 48.0402L332.909 128.006Z"
              fill="#DAEFFF"
            />
            <path
              opacity="0.13"
              d="M350.17 92.064L187.576 82.7668L334.339 127.935L372.608 169.177L350.17 92.064Z"
              fill="#307FF4"
            />
            <path
              d="M372.76 170.532L334.165 127.539L72.4736 47.6313L372.76 170.532Z"
              fill="#73C3FD"
            />
            <path
              d="M71.4562 47.6916L74.1109 48.1454L333.535 129.016L333.82 129.058L281.534 228.367L71.4562 47.6916Z"
              fill="#EFF8FF"
            />
            <path
              d="M71.0765 47.6646L394.254 9.35499L350.344 93.5453L74.441 48.6447L71.0765 47.6646Z"
              fill="#EFF8FF"
            />
          </svg>

          <svg
            class="arrow-2"
            viewBox="0 0 768 214"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M698.289 246.067C674.206 229 609.444 194.853 552.115 169.836C491.812 143.521 445.076 138.642 402.137 153.883C377.181 162.741 375.481 193.95 414.236 208.848C452.992 223.746 506.28 180.4 472.556 134.247C438.832 88.0941 343.645 102.136 273.604 108.179"
              stroke="#C5E4FE"
              stroke-width="3"
              stroke-linecap="round"
              stroke-dasharray="8 8"
            />
            <path
              d="M332.909 128.006L372.462 171.488L349.963 92.8319L71.4301 48.0402L332.909 128.006Z"
              fill="#DAEFFF"
            />
            <path
              opacity="0.13"
              d="M350.17 92.064L187.576 82.7668L334.339 127.935L372.608 169.177L350.17 92.064Z"
              fill="#307FF4"
            />
            <path
              d="M372.76 170.532L334.165 127.539L72.4736 47.6313L372.76 170.532Z"
              fill="#73C3FD"
            />
            <path
              d="M71.4562 47.6916L74.1109 48.1454L333.535 129.016L333.82 129.058L281.534 228.367L71.4562 47.6916Z"
              fill="#EFF8FF"
            />
            <path
              d="M71.0765 47.6646L394.254 9.35499L350.344 93.5453L74.441 48.6447L71.0765 47.6646Z"
              fill="#EFF8FF"
            />
          </svg>
        </div>
      </section>

      <footer>
        <div class="footer-container">
          <div>
            <svg
              width="125"
              height="110"
              viewBox="0 0 125 110"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M124.949 51.9424C124.417 76.9681 102.189 75.2416 101.488 75.1819C101.475 75.1801 101.466 75.1801 101.454 75.1801C101.115 75.1731 95.4739 74.9922 85.1104 69.8041C84.8578 69.6794 84.5505 69.7812 84.4304 70.0359C83.4838 72.0644 79.1144 80.0311 68.2687 81.8084C55.8758 83.837 47.0488 75.8686 45.7171 74.5812C45.6023 74.4723 45.4452 74.4231 45.2897 74.4477C42.3774 74.9149 14.9373 79.4936 2.26008 88.5281V88.5263C-4.28162 66.9624 5.45851 61.012 5.45851 61.012C5.11765 59.981 -2.39364 36.4079 19.4038 27.4472C19.5839 27.3734 19.7058 27.203 19.7146 27.0099C19.8365 24.2753 21.3624 4.56775 39.8607 0.688063C59.7454 -3.48141 68.2687 12.6608 68.2687 12.6608C68.2687 12.6608 83.1482 6.0694 93.2946 13.0648C100.541 18.0615 102.351 25.5012 102.694 27.3172C102.74 27.5526 102.945 27.7212 103.185 27.7212C106.288 27.7247 125.445 28.6819 124.949 51.9424Z"
                fill="white"
              />
              <path
                d="M115.397 43.3874L95.3642 32.616C94.9862 32.4123 94.5429 32.746 94.6383 33.1622C95.2847 35.9951 94.716 39.8906 94.5553 39.7027C94.6895 39.5341 68.3779 40.1927 54.9183 42.1247C48.6045 43.0309 38.1897 45.5108 28.8098 49.6364C16.4664 55.0651 5.50767 61.0348 5.50061 61.012C5.15975 59.9811 -2.35155 36.4079 19.4459 27.4472C19.626 27.3734 19.7479 27.2048 19.7567 27.0099C19.8803 24.2753 21.4063 4.56775 39.9028 0.688063C59.7893 -3.48141 68.3108 12.6608 68.3108 12.6608C68.3108 12.6608 83.1921 6.06941 93.3367 13.0648C100.583 18.0615 102.393 25.5012 102.738 27.3172C102.782 27.5526 102.988 27.7212 103.229 27.7212C106.332 27.7247 125.487 28.6819 124.993 51.9424C124.459 76.9663 102.233 75.2416 101.531 75.1801C101.519 75.1784 101.51 75.1784 101.498 75.1784C101.159 75.1713 95.5178 74.9905 85.1542 69.8041C84.9017 69.6776 84.5944 69.7812 84.4743 70.0359C83.5259 72.0644 79.1565 80.0311 68.3108 81.8067C55.9197 83.837 47.0909 75.8668 45.7592 74.5812C45.6462 74.4723 45.489 74.4232 45.3336 74.4478C42.4213 74.9132 14.9688 79.4954 2.29688 88.5334C2.29688 88.5334 2.40461 88.428 2.61301 88.2278C5.16328 85.7742 22.8156 69.1174 42.204 59.3154C51.1777 54.7789 61.7691 50.8342 71.2584 48.3402C82.1942 45.4652 91.507 44.2428 93.8665 43.96C94.1791 43.9231 94.4458 44.176 94.4246 44.4869C94.3592 45.4423 94.082 47.4656 92.9428 49.9069C92.7627 50.2932 93.1265 50.7112 93.538 50.5918L115.3 44.299C115.729 44.1795 115.791 43.5982 115.397 43.3874Z"
                fill="#70BEF7"
              />
              <path
                d="M12.6457 110C10.7773 110 9.17723 109.605 7.84534 108.814C6.51345 108.004 5.48679 106.855 4.76535 105.365C4.06241 103.875 3.71094 102.099 3.71094 100.039C3.71094 98.4939 3.90517 97.1142 4.29364 95.9001C4.7006 94.6676 5.2833 93.6282 6.04174 92.782C6.81868 91.9174 7.7621 91.2552 8.872 90.7953C10.0004 90.3354 11.2583 90.1055 12.6457 90.1055C13.8666 90.1055 15.0042 90.2802 16.0586 90.6297C17.1131 90.9793 18.0195 91.4943 18.7779 92.175C18.9629 92.3405 19.0831 92.5153 19.1386 92.6993C19.1941 92.8832 19.1941 93.058 19.1386 93.2235C19.1016 93.3707 19.0184 93.4995 18.8889 93.6099C18.7594 93.7018 18.6022 93.7478 18.4172 93.7478C18.2507 93.7294 18.0657 93.6374 17.8622 93.4719C17.1593 92.8648 16.3731 92.4141 15.5037 92.1198C14.6528 91.8255 13.7093 91.6783 12.6734 91.6783C11.1381 91.6783 9.83392 92.0094 8.76101 92.6717C7.7066 93.3155 6.90192 94.2629 6.34696 95.5138C5.81051 96.7647 5.54228 98.2732 5.54228 100.039C5.54228 101.824 5.81051 103.341 6.34696 104.592C6.90192 105.843 7.7066 106.8 8.76101 107.462C9.83392 108.106 11.1381 108.428 12.6734 108.428C13.6908 108.428 14.6343 108.28 15.5037 107.986C16.3731 107.673 17.1686 107.213 17.89 106.606C18.0935 106.441 18.2785 106.358 18.4449 106.358C18.6299 106.358 18.7779 106.413 18.8889 106.524C19.0184 106.616 19.1109 106.744 19.1664 106.91C19.2219 107.057 19.2219 107.213 19.1664 107.379C19.1294 107.545 19.0276 107.701 18.8612 107.848C18.0657 108.566 17.1408 109.108 16.0864 109.476C15.0505 109.826 13.9036 110 12.6457 110Z"
                fill="#73C3FD"
              />
              <path
                d="M26.6283 110C25.3889 110 24.427 109.614 23.7426 108.841C23.0766 108.069 22.7437 106.974 22.7437 105.558V91.0161C22.7437 90.7217 22.8177 90.5102 22.9656 90.3814C23.1136 90.2342 23.3264 90.1607 23.6038 90.1607C23.8628 90.1607 24.0663 90.2342 24.2143 90.3814C24.3623 90.5102 24.4363 90.7217 24.4363 91.0161V105.365C24.4363 106.432 24.649 107.232 25.0745 107.765C25.4999 108.28 26.1196 108.538 26.9336 108.538C27.1185 108.538 27.2758 108.529 27.4053 108.51C27.5348 108.492 27.6642 108.483 27.7937 108.483C27.9602 108.464 28.0805 108.501 28.1545 108.593C28.2469 108.667 28.2932 108.832 28.2932 109.09C28.2932 109.347 28.2284 109.541 28.099 109.669C27.9695 109.798 27.7567 109.89 27.4608 109.945C27.3313 109.964 27.1925 109.973 27.0445 109.973C26.9151 109.991 26.7763 110 26.6283 110Z"
                fill="#73C3FD"
              />
              <path
                d="M35.8759 110C34.618 110 33.5266 109.715 32.6017 109.145C31.6767 108.575 30.9553 107.775 30.4374 106.744C29.9379 105.714 29.6882 104.491 29.6882 103.074C29.6882 102.026 29.8269 101.079 30.1044 100.232C30.4004 99.3861 30.8166 98.6595 31.353 98.0524C31.908 97.427 32.5647 96.9579 33.3231 96.6451C34.1 96.314 34.951 96.1485 35.8759 96.1485C37.1523 96.1485 38.2529 96.4336 39.1779 97.0039C40.1028 97.5741 40.815 98.3835 41.3144 99.4321C41.8324 100.462 42.0914 101.676 42.0914 103.074C42.0914 104.141 41.9434 105.098 41.6474 105.944C41.3699 106.79 40.9537 107.517 40.3988 108.124C39.8623 108.731 39.2149 109.2 38.4564 109.531C37.698 109.844 36.8378 110 35.8759 110ZM35.8759 108.593C36.8008 108.593 37.5962 108.382 38.2622 107.959C38.9466 107.517 39.4646 106.882 39.8161 106.055C40.186 105.227 40.371 104.233 40.371 103.074C40.371 101.327 39.964 99.9748 39.1501 99.0182C38.3547 98.0616 37.2633 97.5833 35.8759 97.5833C34.9695 97.5833 34.174 97.8041 33.4896 98.2456C32.8236 98.6687 32.3057 99.2941 31.9357 100.122C31.5843 100.931 31.4085 101.916 31.4085 103.074C31.4085 104.84 31.8155 106.202 32.6294 107.158C33.4433 108.115 34.5255 108.593 35.8759 108.593Z"
                fill="#73C3FD"
              />
              <path
                d="M50.4399 110C49.367 110 48.4699 109.807 47.7484 109.421C47.0455 109.035 46.5183 108.455 46.1668 107.683C45.8153 106.91 45.6396 105.953 45.6396 104.813V97.0866C45.6396 96.7923 45.7136 96.5716 45.8616 96.4244C46.0096 96.2772 46.2223 96.2036 46.4998 96.2036C46.7588 96.2036 46.9622 96.2772 47.1102 96.4244C47.2582 96.5716 47.3322 96.7923 47.3322 97.0866V104.73C47.3322 106.018 47.6004 106.984 48.1369 107.627C48.6733 108.253 49.515 108.566 50.6619 108.566C51.9198 108.566 52.9372 108.152 53.7142 107.324C54.4911 106.478 54.8796 105.374 54.8796 104.013V97.0866C54.8796 96.7923 54.9536 96.5716 55.1015 96.4244C55.2495 96.2772 55.4623 96.2036 55.7397 96.2036C55.9987 96.2036 56.2022 96.2772 56.3502 96.4244C56.4982 96.5716 56.5722 96.7923 56.5722 97.0866V109.09C56.5722 109.66 56.3039 109.945 55.7675 109.945C55.5085 109.945 55.305 109.872 55.157 109.724C55.0091 109.577 54.9351 109.366 54.9351 109.09V106.358L55.268 106.551C54.9166 107.673 54.3061 108.529 53.4367 109.117C52.5673 109.706 51.5683 110 50.4399 110Z"
                fill="#73C3FD"
              />
              <path
                d="M66.1655 110C64.9631 110 63.9087 109.724 63.0023 109.173C62.1143 108.602 61.4206 107.802 60.9212 106.772C60.4402 105.723 60.1997 104.491 60.1997 103.074C60.1997 101.658 60.4402 100.435 60.9212 99.4045C61.4021 98.3743 62.0866 97.5741 62.9745 97.0039C63.8809 96.4336 64.9446 96.1485 66.1655 96.1485C67.4234 96.1485 68.4963 96.4704 69.3842 97.1142C70.2721 97.7581 70.8641 98.6227 71.1601 99.708H70.8548V91.0161C70.8548 90.7217 70.9288 90.5102 71.0768 90.3814C71.2248 90.2342 71.4283 90.1607 71.6873 90.1607C71.9648 90.1607 72.1775 90.2342 72.3255 90.3814C72.4735 90.5102 72.5475 90.7217 72.5475 91.0161V109.09C72.5475 109.366 72.4735 109.577 72.3255 109.724C72.1775 109.872 71.974 109.945 71.715 109.945C71.4375 109.945 71.2248 109.872 71.0768 109.724C70.9288 109.577 70.8548 109.366 70.8548 109.09V106.248L71.1601 106.441C70.8641 107.526 70.2721 108.391 69.3842 109.035C68.4963 109.679 67.4234 110 66.1655 110ZM66.3875 108.593C67.3124 108.593 68.1078 108.382 68.7738 107.959C69.4582 107.517 69.9762 106.882 70.3276 106.055C70.6976 105.227 70.8826 104.233 70.8826 103.074C70.8826 101.327 70.4756 99.9748 69.6617 99.0182C68.8663 98.0616 67.7749 97.5833 66.3875 97.5833C65.481 97.5833 64.6856 97.8041 64.0012 98.2456C63.3352 98.6687 62.8173 99.2941 62.4473 100.122C62.0958 100.931 61.9201 101.916 61.9201 103.074C61.9201 104.84 62.3271 106.202 63.141 107.158C63.9549 108.115 65.0371 108.593 66.3875 108.593Z"
                fill="#73C3FD"
              />
              <path
                d="M76.6318 109.945C76.3913 109.945 76.1971 109.89 76.0491 109.78C75.9196 109.688 75.8456 109.55 75.8271 109.366C75.8271 109.182 75.8733 108.979 75.9658 108.759L83.7629 90.9333C83.8924 90.6573 84.0497 90.4642 84.2346 90.3538C84.4196 90.225 84.6046 90.1607 84.7896 90.1607C85.0116 90.1607 85.2058 90.225 85.3723 90.3538C85.5573 90.4642 85.7053 90.6573 85.8163 90.9333L93.6133 108.759C93.7243 108.979 93.7706 109.182 93.7521 109.366C93.7521 109.55 93.6873 109.688 93.5578 109.78C93.4469 109.89 93.2711 109.945 93.0306 109.945C92.7717 109.945 92.5589 109.881 92.3924 109.752C92.2445 109.605 92.115 109.412 92.004 109.173L89.8674 104.178L90.7831 104.592H78.7683L79.7118 104.178L77.5752 109.173C77.4642 109.449 77.3255 109.651 77.159 109.78C77.011 109.89 76.8353 109.945 76.6318 109.945ZM84.7618 92.4233L80.0447 103.461L79.4065 103.13H90.1449L89.5622 103.461L84.8173 92.4233H84.7618Z"
                fill="#73C3FD"
              />
              <path
                d="M102.376 110C101.063 110 99.9342 109.715 98.9908 109.145C98.0473 108.556 97.3166 107.738 96.7987 106.689C96.2992 105.622 96.0495 104.39 96.0495 102.992C96.0495 101.925 96.1882 100.977 96.4657 100.15C96.7617 99.3033 97.1779 98.5859 97.7144 97.9972C98.2693 97.4086 98.9353 96.9579 99.7122 96.6451C100.508 96.314 101.396 96.1485 102.376 96.1485C103.06 96.1485 103.763 96.268 104.485 96.5072C105.206 96.7279 105.863 97.105 106.455 97.6385C106.584 97.7489 106.668 97.8777 106.705 98.0248C106.742 98.172 106.732 98.3192 106.677 98.4663C106.621 98.5951 106.538 98.7055 106.427 98.7974C106.316 98.871 106.177 98.917 106.011 98.9354C105.863 98.9354 105.706 98.8618 105.539 98.7147C105.021 98.2916 104.494 98.0064 103.958 97.8593C103.44 97.6937 102.931 97.6109 102.431 97.6109C101.673 97.6109 101.007 97.7305 100.434 97.9696C99.8602 98.2088 99.37 98.5583 98.963 99.0182C98.5745 99.4781 98.2786 100.048 98.0751 100.729C97.8716 101.391 97.7699 102.155 97.7699 103.019C97.7699 104.748 98.1676 106.11 98.963 107.103C99.7769 108.078 100.933 108.566 102.431 108.566C102.931 108.566 103.44 108.492 103.958 108.345C104.494 108.179 105.021 107.885 105.539 107.462C105.706 107.315 105.863 107.25 106.011 107.269C106.177 107.269 106.316 107.315 106.427 107.407C106.538 107.48 106.612 107.591 106.649 107.738C106.705 107.867 106.714 108.004 106.677 108.152C106.64 108.299 106.557 108.428 106.427 108.538C105.854 109.071 105.206 109.449 104.485 109.669C103.763 109.89 103.06 110 102.376 110Z"
                fill="#73C3FD"
              />
              <path
                d="M114.695 110C113.697 110 112.864 109.816 112.198 109.449C111.532 109.081 111.033 108.556 110.7 107.876C110.367 107.177 110.2 106.321 110.2 105.31V97.7489H108.147C107.907 97.7489 107.712 97.6937 107.564 97.5833C107.416 97.4546 107.342 97.2798 107.342 97.059C107.342 96.8567 107.416 96.7003 107.564 96.59C107.712 96.4612 107.907 96.3968 108.147 96.3968H110.2V92.9476C110.2 92.6533 110.274 92.4417 110.422 92.313C110.57 92.1658 110.783 92.0922 111.061 92.0922C111.32 92.0922 111.523 92.1658 111.671 92.313C111.819 92.4417 111.893 92.6533 111.893 92.9476V96.3968H115.639C115.898 96.3968 116.092 96.4612 116.222 96.59C116.351 96.7003 116.416 96.8567 116.416 97.059C116.416 97.2798 116.351 97.4546 116.222 97.5833C116.092 97.6937 115.898 97.7489 115.639 97.7489H111.893V105.089C111.893 106.211 112.124 107.066 112.587 107.655C113.049 108.244 113.817 108.538 114.89 108.538C115.26 108.538 115.565 108.501 115.805 108.428C116.064 108.336 116.277 108.29 116.444 108.29C116.573 108.29 116.684 108.345 116.777 108.455C116.888 108.566 116.943 108.74 116.943 108.979C116.943 109.127 116.906 109.274 116.832 109.421C116.777 109.568 116.666 109.66 116.499 109.697C116.296 109.77 116.018 109.835 115.667 109.89C115.315 109.964 114.991 110 114.695 110Z"
                fill="#73C3FD"
              />
              <path
                d="M120.07 109.862C119.7 109.862 119.394 109.743 119.154 109.504C118.913 109.265 118.793 108.961 118.793 108.593C118.793 108.225 118.913 107.922 119.154 107.683C119.394 107.443 119.7 107.324 120.07 107.324C120.458 107.324 120.763 107.443 120.985 107.683C121.226 107.922 121.346 108.225 121.346 108.593C121.346 108.961 121.226 109.265 120.985 109.504C120.763 109.743 120.458 109.862 120.07 109.862Z"
                fill="#73C3FD"
              />
            </svg>

            <div class="footer-logo-text">
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M2 12C2 6.477 6.477 2 12 2C17.523 2 22 6.477 22 12C22 17.523 17.523 22 12 22C6.477 22 2 17.523 2 12Z"
                  stroke="#171D34"
                  stroke-width="1.5"
                />
                <path
                  d="M14 15.667C13.4556 15.888 12.8735 16.0011 12.286 16C9.919 16 8 14.21 8 12C8 9.79 9.919 8 12.286 8C12.896 8 13.475 8.119 14 8.333"
                  stroke="#171D34"
                  stroke-width="1.5"
                  stroke-linecap="round"
                />
              </svg>

              <div>2025 CloudAct. All rights Reserved.</div>
            </div>
          </div>

          <div class="footer-links">
            <h4>Contact Us</h4>

            <div class="footer-link">
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M20 5H4C3.44772 5 3 5.44772 3 6V18C3 18.5523 3.44772 19 4 19H20C20.5523 19 21 18.5523 21 18V6C21 5.44772 20.5523 5 20 5Z"
                  stroke="#73C3FD"
                  stroke-width="1.5"
                  stroke-linecap="round"
                />
                <path
                  d="M3 6.5L12 12L21 6.5"
                  stroke="#73C3FD"
                  stroke-width="1.5"
                  stroke-linecap="round"
                />
              </svg>

              <a href="mailto:talk@cloudforlawfirms.com">
                talk@cloudforlawfirms.com
              </a>
            </div>

            <div class="footer-link">
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M15 7C15.5304 7 16.0391 7.21071 16.4142 7.58579C16.7893 7.96086 17 8.46957 17 9M15 3C16.5913 3 18.1174 3.63214 19.2426 4.75736C20.3679 5.88258 21 7.4087 21 9M5 4H9L11 9L8.5 10.5C9.57096 12.6715 11.3285 14.429 13.5 15.5L15 13L20 15V19C20 19.5304 19.7893 20.0391 19.4142 20.4142C19.0391 20.7893 18.5304 21 18 21C14.0993 20.763 10.4202 19.1065 7.65683 16.3432C4.8935 13.5798 3.23705 9.90074 3 6C3 5.46957 3.21071 4.96086 3.58579 4.58579C3.96086 4.21071 4.46957 4 5 4Z"
                  stroke="#73C3FD"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>

              <a href="tel:+14169854978">416-985-4978</a>
            </div>

            <div class="footer-media">
              <div class="media-icon">
                <svg
                  width="36"
                  height="36"
                  viewBox="0 0 36 36"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M12 16.5V24M12 12V12.015M18 24V16.5M24 24V19.5C24 18.7044 23.6839 17.9413 23.1213 17.3787C22.5587 16.8161 21.7956 16.5 21 16.5C20.2044 16.5 19.4413 16.8161 18.8787 17.3787C18.3161 17.9413 18 18.7044 18 19.5M6 9C6 8.20435 6.31607 7.44129 6.87868 6.87868C7.44129 6.31607 8.20435 6 9 6H27C27.7956 6 28.5587 6.31607 29.1213 6.87868C29.6839 7.44129 30 8.20435 30 9V27C30 27.7956 29.6839 28.5587 29.1213 29.1213C28.5587 29.6839 27.7956 30 27 30H9C8.20435 30 7.44129 29.6839 6.87868 29.1213C6.31607 28.5587 6 27.7956 6 27V9Z"
                    stroke="white"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </div>

              <div class="media-icon">
                <svg
                  width="36"
                  height="36"
                  viewBox="0 0 36 36"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M10.5 15V21H15V31.5H21V21H25.5L27 15H21V12C21 11.6022 21.158 11.2206 21.4393 10.9393C21.7206 10.658 22.1022 10.5 22.5 10.5H27V4.5H22.5C20.5109 4.5 18.6032 5.29018 17.1967 6.6967C15.7902 8.10322 15 10.0109 15 12V15H10.5Z"
                    stroke="white"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </Layout>
  );
};

export default Home;
